export default __webpack_public_path__ + "static/media/img-industry-hospitality.17cc8e2a.svg";